import { render, staticRenderFns } from "./PendingPost.vue?vue&type=template&id=9f11d438&scoped=true"
import script from "./PendingPost.vue?vue&type=script&lang=js"
export * from "./PendingPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f11d438",
  null
  
)

export default component.exports